/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        var home = this;
        this.listingLinks();
        $('.js--menu').click(function (e) {
          e.preventDefault();
          $('.nav-overlay').fadeIn().css('display', 'flex');
          $('html').addClass('overflow');
        })
        $('.js--menu-close').click(function (e) {
          e.preventDefault();
          $('.nav-overlay').fadeOut();
          $('html').removeClass('overflow');
        })

        $('.js--book').click(function (e) {
          e.preventDefault();
          $('.book-overlay').fadeIn().css('display', 'flex');
        })
        $('.js--book-close').click(function (e) {
          e.preventDefault();
          $('.book-overlay').fadeOut();
        })


        $('.js--arrow--top').click(function (e) {
          e.preventDefault();
          $("html, body").animate({
            scrollTop: 0
          });
        })
        if ($('.info-gallery').length != 0) {
          $('.info-gallery').flickity({
            imagesLoaded: true,
            prevNextButtons: true,
            adaptiveHeight:true
          });
        }

        $('.js--search').click(function (e) {
          e.preventDefault();
          var $search = $(this);
          if ($search.hasClass('expanded')) {
            $(this).siblings('.search-form').submit();

          } else {
            $(this).siblings('.search-form').fadeIn(function () {
              $('.search-field', $(this)).focus();
              $search.addClass('expanded');
            }).css('display', 'inline-block');
          }
        })


        $('.js--newsletter').submit(function (e) {
          e.preventDefault();
          var $form = $(this);
          var email = $('.js--newsletter-email', $form).val();
          $form.children('.js--newsletter-error').html('');
          if (email == '') {
            $form.children('.js--newsletter-error').append("<span class='newsletter-error__message'>Please enter a valid email</span>");
          } else {

            $.ajax({
              url: '/register.php',
              type: 'post',
              dataType: 'json',
              success: function (data) {
                console.log(data);
                if ((data.title == 'Member Exists') || (data.status == "pending")) {
                  $form.fadeOut(function () {
                    $('.form__success').fadeIn();
                  })
                } else if (data.title == 'Invalid Resource') {
                  $form.children('.js--newsletter-error').append("<span class='newsletter-error__message'>Please enter a valid email</span>");
                }
              },
              data: {
                'email': email
              }
            });
          }
        })        

        $('.js--arrow--more').click(function (e) {
          e.preventDefault();
          $('.js--arrow--more').children('.js--top__text').html('Loading');
          var page = $(this).data('page');
          var type = $(this).data('type');
          var direction = $(this).data('direction');
          /*
          var category = $(this).data('category');
          var tag = $(this).data('tag');
          var artist = $(this).data('artist');
          var search = $(this).data('search');*/
          var that = this;
          if (type == 'listings') {
            jQuery.ajax({
                type: "POST",
                url: '/wp-admin/admin-ajax.php',
                data: {
                  'action': 'get_ajaxposts',
                  'page': page,
                  'type': type,
                  'direction':direction
                },
                dataType: 'JSON'
              })
              .done(function (response) {
                $('.js--arrow--more').children('.js--top__text').html('More');
                $(that).data('page', page + 1);
                $('.js--posts').append(response.posts);
                home.listingLinks();
                if (response.maxpages <= $(that).data('page')) {
                  $('.js--arrow--more').addClass('hide');
                }
              })

          } else {
          // mobile home page
            jQuery.ajax({
              type: "POST",
              url: '/wp-admin/admin-ajax.php',
              data: {
                'action': 'get_ajaxposts',
                'page': page,
                'type':'listingsneat'
              },
              dataType: 'JSON'
            })
              .done(function (response) {
                console.log(response);
                $('.js--posts').append(response.posts);
                home.listingLinks();
              })

            for (i = 1; i < 4; i++) {
              jQuery.ajax({
                  type: "POST",
                  url: '/wp-admin/admin-ajax.php',
                  data: {
                    'action': 'get_ajaxposts',
                    'page': page,
                    'type': type,
                    'column': i
                  },
                  dataType: 'JSON'
                })
                .done(function (response) {
                  $('.js--arrow--more').children('.js--top__text').html('More');

                  var column = response.column;
                  if (column == 1) {
                    $(that).data('page', page + 1);
                  }
                  $('.js--posts-' + column).append(response.posts);
                  home.listingLinks();

                  if (response.maxpages <= $(that).data('page')) {
                    $('.js--arrow--more').addClass('hide');

                  }
                })
            }


          }

        })

      },
      listingLinks: function () {
        $('.js--listing-toggle').unbind("click").click(function (e) {
          e.preventDefault();
          var $listing = $(this).parents('.listing-item');
          if ($listing.hasClass('expanded')) {
            $listing.removeClass('expanded');
            $listing.find('.listing__blurb').slideUp(250);
          } else {
            $openlisting = $('.listing-item.expanded');
            $openlisting.removeClass('expanded');
            $openlisting.find('.listing__blurb').slideUp(250);
            $listing.addClass('expanded');
            $listing.find('.listing__blurb').slideDown(250);
          }
        })


      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
